import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { Loading } from "components";
import AuthService, { UserProfile } from "services/axios/AuthService";

const RedirectToDashboard = React.memo(({ ...rest }) => {
  const [userLoggedIn, setUserLoggedIn] = useState<any>();
  const [currentUser, setCurrentUser] = useState<UserProfile>();
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const user = await AuthService.isLoggedIn();
        const currentUser = await AuthService.fetchCurrentUserFromStorage();
        setUserLoggedIn(user);
        setCurrentUser(currentUser);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    fetchCurrentUser();
  }, []);

  if (loading) return <Loading />;
  return <Route
    {...rest}
    render={
      routeProps => {
        if (!!userLoggedIn && currentUser) {
          return <Redirect to={`${currentUser.role}/dashboard`} />;
        } else {
          return <Redirect to={"/login"} />;
        }
      }
    }
  />
});

export default RedirectToDashboard;